import { Client } from '../EnumTypes/ActionEnumTypes';
import { getClientStats as getClientStatsConnector } from 'Connectors/ClientConnector';
import * as ViewManagementModule from 'Modules/ViewManagementModule';

const init = () => ({
    type: Client.GET_CLIENT_STATS_INIT,
});

const success = (data) => ({
    type: Client.GET_CLIENT_STATS_SUCCESS,
    payload: {
        data,
    },
});

const failure = () => ({
    type: Client.GET_CLIENT_STATS_FAILURE,
});

const getClientStats = (params) => async (dispatch) => {
    dispatch(init());
    try {
        dispatch(ViewManagementModule.Actions.showLoader());
        const { data } = await getClientStatsConnector(params);
        dispatch(success(data));
        dispatch(ViewManagementModule.Actions.hideLoader());
    } catch (err) {
        dispatch(ViewManagementModule.Actions.hideLoader());
        dispatch(failure());
    }
};

export default getClientStats;
